// extracted by mini-css-extract-plugin
module.exports = {"content":"member_content__1OLu0","imgBorder":"member_imgBorder__3b-pE","popup":"member_popup__1UC3k"};